import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import 'regenerator-runtime/runtime';
import App from './App';
import './registerExpressionWorker';
import { reloadOnPreloadError } from './reloadOnPreloadError';
import reportWebVitals from './reportWebVitals';
import './styles/index.css';

/** Set by index.html while it sends a plugin's OAuth2 sign-in on to a tenant's subdomain. */
const isForwardingOAuth2Return = document.documentElement.dataset.forwardingOauth2Return === 'true';

window.addEventListener('vite:preloadError', (event) => reloadOnPreloadError(event));

if (!isForwardingOAuth2Return) {
    ReactDOM.render(
        <React.StrictMode>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </React.StrictMode>,
        document.getElementById('root')
    );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
